var GenesisRouterConstants = /** @class */ (function () {
    function GenesisRouterConstants() {
    }
    GenesisRouterConstants.RouteNames = {
        Home: "home",
        Audits: "audits",
        Dashboard: "dashboard",
        ManageLookups: "lookups",
        ManageSystemConfigurations: "system-configuations",
        ManageDefaultTemplateTheme: "ManageDefaultTemplateTheme",
        ManageDefaultOverlayTheme: "ManageDefaultOverlayTheme",
        ManageDefaultWidgetTheme: "ManageDefaultWidgetTheme",
        //SupportPage: "SupportPage",
        GlobalBilling: "GlobalBilling",
        ManageStatusReasonTransition: "ManageStatusReasonTransition",
        ManageTemplates: "manage-templates",
        ManageLotteryWidgets: "manage-lottery-widgets",
        ManagePermissions: "permissions",
        ManageUsers: "users",
        ManageBranches: "manage-branches",
        Logs: "logs",
        ManageValidations: "manage-validations",
        Login: "login",
        Register: "register",
        ForgotPassword: "forgotPassword",
        ResetPassword: "resetPassword",
        ListVideoCalls: "manage-video-calls",
        OnboardingRequest: "onboarding-request",
        Onboardings: "onboardings-list",
        PersistOnboarding: "persist-onboarding",
        ChangePassword: "change-password",
        ManageUserDashboards: "manage-user-dashboards",
        SupportPage: "support-page"
    };
    return GenesisRouterConstants;
}());
export { GenesisRouterConstants };
var RouterConstants = /** @class */ (function () {
    function RouterConstants() {
    }
    RouterConstants.RouteNames = {
        TermsAndConditions: "TermsAndConditions",
        Lobby: "lobby",
        Lottery: "lottery",
        Lotteries: "lotteries",
        Bundle: "bundle",
        Bundles: "bundles",
        Syndicate: "syndicate",
        Results: "results",
        Purchases: "purchases",
        AgentWinningClaims: "agent-winning-claims",
        Cart: "cart",
        ManageBrands: "manage-brands",
        ManageLottery: "manage-lottery",
        ManageInstantGame: "manage-instant-game",
        ManageSweepstakes: "manage-sweepstake",
        ManageBundle: "manage-bundle",
        ManageSyndicate: "manage-syndicate",
        ManageWinningNominationClaim: "manage-winning-nomination-claim",
        ManageInstantGameWinningClaim: "manage-instant-game-winning-claim",
        ManageSweepstakeWinningClaim: "manage-sweepstake-winning-claim",
        CreateWinningNominationClaim: "create-winning-nomination-claim",
        WinSimulation: "win-simulation",
        ManagePlayer: "manage-player",
        ListPlayers: "list-player",
        ListBrands: "list-brands",
        ListOperators: "list-operators",
        ListTransactions: "list-transactions",
        ListTransactionDetails: "list-transaction-details",
        ListSweepstakeTicketLines: "list-sweepstake-ticket-lines",
        ManageTransaction: "manage-transaction",
        ListWinningNominationClaims: "list-winning-nomination-claims",
        ListInstantGamesWinningClaims: "list-instant-games-winning-claims",
        ListSweepstakeWinningClaims: "list-sweepstake-winning-claims",
        ListTicketLines: "list-ticket-lines",
        ManageTicketLine: "manage-ticket-line",
        ManageTicketDraw: "manage-ticket-draw",
        ListLotteries: "list-lotteries",
        ListAffiliateLinkAnalytics: "list-affiliate-link-analytics",
        ListInstantGames: "list-instant-games",
        ListSweepstakes: "list-sweepstakes",
        ManageBrand: "manage-brand",
        ManageOperator: "manage-operator",
        ManageBrandings: "manage-brandings",
        Manage: "manage",
        Leaderboard: "Leaderboard",
        MyProfile: "my-profile",
        ListTicketLineDraws: "list-ticket-line-draws",
        ManageApiSettings: "manage-api-settings",
        ListApiSettings: "list-api-settings",
        TopUp: "topup",
        InsuranceAccount: "insurance-account",
    };
    return RouterConstants;
}());
export { RouterConstants };
